export default "__VITE_ASSET__oYnM7pK9__"